var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recipe-admin-notes-post"},[_c('div',{staticClass:"media my-3"},[_c('span',{staticClass:"author-image",style:(_vm.styles)}),_c('div',{staticClass:"media-body"},[(_vm.title)?_c('h4',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }